import React from 'react'
import isFunction from 'lodash/isFunction'
import { LKButton } from 'loankeeper-common/components'
import { useWindow } from 'loankeeper-common/components/Window'

import { useLKModal } from './LKModalContext'

// TODO: add default text in translations
export const CancelButton = ({ text, onClick, disabled, ...rest }) => {
  const { closeBlocked } = useLKModal()
  const { onClose } = useWindow()

  const handleClick = React.useCallback(() => {
    if (isFunction(onClick)) {
      onClick()
    }

    onClose()
  }, [onClose, onClick])

  return <LKButton.Cancel {...rest} onClick={handleClick} text={text} disabled={closeBlocked || disabled} />
}
